import { FC } from 'react'
import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import { FlexboxGrid } from 'rsuite'

import SafeTranslate from '../../common/SafeTranslate'
import ShieldIcon from '../../Icons/ShieldIcon'
import useIsOnMobile from '../../../services/useIsOnMobile'
import { ScreenSize } from '../../../utils/constants'
import PaymentIconsSection from '../../Cart/PaymentIconsSection'
import ShippingServiceLogos from './ShippingServiceLogos/ShippingServiceLogos'

import styles from '../../../styles/Footer.module.less'

const CheckoutFooter: FC = () => {
  const { t } = useTranslation('checkout')
  const isOnMobile = useIsOnMobile(ScreenSize.md)

  return (
    <div className={styles['footer-container']}>
      <footer className={`${styles.footer} ${styles['-checkout']} hide-on-print`}>
        <FlexboxGrid
          className={`max-width-lg ${styles['checkout-footer-content']}`}
          justify="space-between"
          align="middle"
        >
          <FlexboxGrid.Item
            className={styles['checkout-footer-left-col']}
            colspan={isOnMobile ? 24 : undefined}
          >
            <div>
              <div className="h3">{t('common:We accept')}</div>
              <PaymentIconsSection />
            </div>

            <div>
              <span className="h3">{t('common:We ship with')}</span>
              <ShippingServiceLogos />
            </div>
          </FlexboxGrid.Item>

          <FlexboxGrid.Item
            colspan={isOnMobile ? 24 : undefined}
            className={`${isOnMobile ? '' : 'padding-right-spacer-double'} ${styles['checkout-footer-right-col']}`}
          >
            <FlexboxGrid
              align="middle"
              className={`${styles['footer-safe-place-wrapper']}`}
            >
              <ShieldIcon />
              <div className={`margin-left-spacer ${styles['footer-safe-place-text']}`}>
                <SafeTranslate
                  i18nKey="checkout:You are in a safe place Orders are protected by 256-bit SSL encryption"
                  components={{ p: <p /> }}
                />
              </div>
            </FlexboxGrid>

            <FlexboxGrid className={`${styles['footer-links-wrapper']} padding-top-spacer ${isOnMobile ? 'margin-top-spacer-double' : ''}`}>
              <Link
                data-testid="checkout-footer-link"
                href="#contact"
              >
                {t('common:Contact us')}
              </Link>
              <Link
                data-testid="checkout-footer-link"
                href="https://droppe.com/tos#tos-droppe-privacy-policy"
                target="_blank"
              >
                {t('common:Privacy policy')}
              </Link>
            </FlexboxGrid>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </footer>
    </div>
  )
}

export default CheckoutFooter
